import { StoreStatus, StoreStatusType } from "./StoreStatus";

export interface StoreStateBase {
  storeStatus: StoreStatusType;
  error: string | null;
}

export const initialStoreStateBase: StoreStateBase = {
  storeStatus: StoreStatus.idle,
  error: null
};